window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.lazyClass = 'b-lazy';

export default class LazySizesConfig {
}